import React, { Component } from 'react';
import { bool } from 'prop-types';
import { Listing } from 'modules';
import { withBrowserHistory } from 'connectors';
import { locationShape } from 'shapes';
import { hasLocationChanged } from 'utils';
import './InstantSearchRoot.scss';

class InstantSearchRoot extends Component {
    static propTypes = {
        location: locationShape.isRequired,
        ssrRender: bool,
    };

    static defaultProps = {
        ssrRender: false,
    };

    shouldComponentUpdate(nextProps) {
        return hasLocationChanged(nextProps.location, this.props.location);
    }

    render() {
        return (
            <div className="instant-search">
                <Listing ssrRender={this.props.ssrRender} />
            </div>
        );
    }
}

export default withBrowserHistory(InstantSearchRoot);
